import React, { createContext, useContext, useMemo, useState } from 'react';
import { allSupportedFileTypeMappings } from './const';
import { convertToTypeState } from './utils';
const DEFAULT_MAX_UPLOADS_UNSET = 0;
const DEFAULT_MAX_FILE_SIZE_IN_KB = 0;
const DEFAULT_SUPPORTED_FILE_TYPES = convertToTypeState(allSupportedFileTypeMappings);
const UploadConfigurationContext = createContext({
    maxFileSizeInKilobytes: DEFAULT_MAX_FILE_SIZE_IN_KB,
    maxUploads: DEFAULT_MAX_UPLOADS_UNSET,
    supportedFileTypes: DEFAULT_SUPPORTED_FILE_TYPES,
});
/**
 * Provider context for the UploadFileTypesProvider
 */
export const useUploadConfiguration = () => {
    return useContext(UploadConfigurationContext);
};
const { Provider } = UploadConfigurationContext;
/**
 * Provider whose context provides the supported configuration for the upload manager
 * This provider is optional and will return:
 *       0 to indicate no max file size will be checked
 *       0 to indicate no max uploads will be checked
 *       basicImageFileTypeMappings will be used if no file types are passed in
 */
export const UploadConfigurationProvider = (props) => {
    const { maxFileSizeInKilobytes = DEFAULT_MAX_FILE_SIZE_IN_KB, maxUploads = DEFAULT_MAX_UPLOADS_UNSET, supportedFileTypes = undefined, children, } = props;
    const [fileTypeStore] = useState(convertToTypeState(supportedFileTypes || allSupportedFileTypeMappings));
    const value = useMemo(() => ({
        maxFileSizeInKilobytes,
        maxUploads,
        supportedFileTypes: fileTypeStore,
    }), [maxFileSizeInKilobytes, maxUploads, fileTypeStore]);
    return React.createElement(Provider, { value: value }, children);
};
UploadConfigurationProvider.displayName = 'UploadConfigurationProvider';
//# sourceMappingURL=UploadConfigurationProvider.js.map